import { render } from "./contractDetailChangeCard.vue?vue&type=template&id=719544aa&ts=true"
import script from "./contractDetailChangeCard.vue?vue&type=script&lang=ts"
export * from "./contractDetailChangeCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__